import { DisplayMarket, MarketsSort, Percent, SortBy } from '@silo/types';
import { Markets, useLoadMore } from '@silo/ui';
import { MarketCards, PulseMarketCards } from './market-cards';
import { MarketsTable, PulseMarketsTable } from './markets-table';
import { forwardRef } from 'react';

interface MarketsListProps {
  allMarkets: DisplayMarket[];
  markets: DisplayMarket[];
  loadMore: () => Promise<void>;
  showCards: boolean;
  hasMorePages: boolean;
  marketsSort: MarketsSort;
  sortBy: SortBy;
  revenueApr: Percent;
}

export function MarketsList({
  loadMore,
  allMarkets,
  markets,
  showCards,
  hasMorePages,
  marketsSort,
  sortBy,
  revenueApr,
}: MarketsListProps): JSX.Element {
  const { ref, pageSize } = useLoadMore(loadMore);

  const hasMarkets = allMarkets.length > 0;
  const hasMatchingMarkets = markets.length > 0;

  if (!hasMarkets) {
    return <Markets.NoMarkets />;
  }

  if (!hasMatchingMarkets) {
    return <Markets.NoMatchingMarkets />;
  }

  return (
    <>
      {showCards ? (
        <MarketCards markets={markets} revenueApr={revenueApr} />
      ) : (
        <MarketsTable
          markets={markets}
          hasMorePages={hasMorePages}
          marketsSort={marketsSort}
          sortBy={sortBy}
          revenueApr={revenueApr}
        />
      )}

      {hasMorePages && <PulseMarketsList ref={ref} showCards={showCards} pageSize={pageSize} />}
    </>
  );
}

interface PulseMarketsListProps {
  showCards: boolean;
  pageSize: number;
}

const PulseMarketsList = forwardRef<HTMLDivElement, PulseMarketsListProps>(({ showCards, pageSize }, ref) => {
  return showCards ? (
    <PulseMarketCards ref={ref} pageSize={pageSize} />
  ) : (
    <PulseMarketsTable ref={ref} pageSize={pageSize} />
  );
});
